export const GlossaryFiltering = () => {
    function buildGroupedGlossary(sourceId, destinationId) {
        const source = document.getElementById(sourceId);
        const destination = document.getElementById(destinationId);

        if (!source || !destination) {
            console.error('Glossary source or destination element is missing');
            return;
        }
        destination.innerHTML = '';
        const sourceItems = source.querySelectorAll('.jet-listing-grid__item');
        console.log(sourceItems.length + ' glossary items found');
        const itemsGrouped = {};
        for (const itemEl of sourceItems) {
            const titleEl = itemEl.querySelector('.glossary-post__title .jet-listing-dynamic-field__content');
            if (titleEl) {
                const title = titleEl.textContent;
                const firstLetter = title[0];
                if (itemsGrouped[firstLetter] === undefined) {
                    itemsGrouped[firstLetter] = [];
                }
                itemsGrouped[firstLetter].push(itemEl);
            }
        }
        console.log(itemsGrouped);
        for (const letter in itemsGrouped) {
            const items = itemsGrouped[letter];
            const div = document.createElement('div');

            const letterDiv = document.createElement('div');
            letterDiv.textContent = letter;
            letterDiv.classList.add('letter');

            div.appendChild(letterDiv);
            for(const itemEl of items) {
                div.appendChild(itemEl.cloneNode(true));
            }
            destination.appendChild(div);
        }

        // No results handler
        if (Object.keys(itemsGrouped).length === 0) {
            const div = document.createElement('div');
            div.textContent = 'No results found';
            div.classList.add('no-results');
            destination.appendChild(div);
        }
    }

    const observeDOM = (function () {
        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

        return function (obj, callback) {
            if (!obj || obj.nodeType !== 1) return;

            if (MutationObserver) {
                // define a new observer
                var mutationObserver = new MutationObserver(callback);

                // have the observer observe for changes in children
                mutationObserver.observe(obj, {childList: true, subtree: true});
                return mutationObserver;
            }

            // browser support fallback
            else if (window.addEventListener) {
                obj.addEventListener('DOMNodeInserted', callback, false);
                obj.addEventListener('DOMNodeRemoved', callback, false);
            }
        }
    })();

    buildGroupedGlossary('glossary-original', 'glossary-grouped');
    // Observe a specific DOM element:
    observeDOM(document.getElementById('glossary-original'), function(){
        buildGroupedGlossary('glossary-original', 'glossary-grouped');
    });
}